import React from 'react';
import c from 'classnames';

import { SearchFacets as RSKSearchFacets } from '@uncinc/react-searchkit';

export interface SearchTopicalFacetsProps {
  className?: string;
  children: React.ReactNode;
}

const SearchTopicalFacets: React.FC<SearchTopicalFacetsProps> = (props) => {
  const { className, children } = props;
  const classNames = c('SearchTopical__Facets', className);

  return (
    <RSKSearchFacets className={classNames}>
      {children}
    </RSKSearchFacets>
  );
};

export default SearchTopicalFacets;
